import asMyList from '../../components/asMyList.js';
import ABSWineAgenciesCatalogue from './ABSWineAgenciesCatalogue';

// This follows the naming conventions from Classic
export const templates = {
  'brn:print:540eb3403000ce0d1be9ef17:wine.abs.portfolioTasting': asMyList(
    ABSWineAgenciesCatalogue
  ),
};
